import { Button, ButtonType, PageWithHeader } from 'modules/ui';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { ContactForm } from '../contactForm';

export interface ContactPageProps {}

export const ContactPage: React.FC<ContactPageProps> = () => {
  const { t } = useTranslation();

  const [formTitle, setFormTitle] = useState<string>(t('contactPage.title'));

  return (
    <PageWithHeader
      title={formTitle}
      backButton={{
        text: t('contactPage.backToLandingPage'),
        toPath: '/',
      }}>
      <Button
        type={ButtonType.Action}
        text={t('contactPage.userGuide')}
        onClick={() =>
          window.open('https://unicreditleasing.hr/home/podrska', '_blank')
        }
      />
      <ContactForm setFormTitle={setFormTitle} />
    </PageWithHeader>
  );
};
